var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabelsSmallGreenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11464",
    "data-name": "Group 11464",
    transform: "translate(-714 -47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11452",
    "data-name": "Group 11452",
    transform: "translate(726.973 47)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0.027 11)",
    fill: "#29a19c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0.027 5)",
    fill: "#29a19c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0.027)",
    fill: "#29a19c"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4714",
    "data-name": "Line 4714",
    x1: 12.108,
    transform: "translate(714.108 48.135)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4715",
    "data-name": "Line 4715",
    x1: 12,
    transform: "translate(714 54)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4716",
    "data-name": "Line 4716",
    x1: 12,
    transform: "translate(714 60)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelsSmallGreenIcon);
export default __webpack_public_path__ + "static/media/LabelsSmallGreenIcon.40aace20776515b0c7fa2045e55b2ba6.svg";
export { ForwardRef as ReactComponent };